import { GetAllProfessionalsParams } from 'domain/models';
import { ProfessionalServiceInterface } from 'domain/services';
import {
  CreateProfessionalManagementUseCaseInterface,
  GetAllCheckProfessionalExistsUseCaseInterface,
  GetAllProfessionalsSelectOptionsUseCaseInterface,
  GetAllProfessionalsUseCaseInterface,
  UnlinkProfessionalUseCaseInterface,
  GetByIdProfessionalManagementUseCaseInterface,
  UpdateProfessionalManagementUseCaseInterface,
  GetAllProfessionalsNotPaginatedUseCaseInterface,
  GetProfessionalOverviewUseCaseInterface,
} from 'domain/usecases';

export class ProfessionalService implements ProfessionalServiceInterface {
  constructor(
    private readonly _getAllProfessionalsUseCase: GetAllProfessionalsUseCaseInterface,
    private readonly _getAllProfessionalsSelectOptionsUseCase: GetAllProfessionalsSelectOptionsUseCaseInterface,
    private readonly _unlinkProfessionalUseCase: UnlinkProfessionalUseCaseInterface,
    private readonly _getAllCheckProfessionalExists: GetAllCheckProfessionalExistsUseCaseInterface,
    private readonly _createProfessionalManagementUseCase: CreateProfessionalManagementUseCaseInterface,
    private readonly _getByIdProfessionalManagementUseCase: GetByIdProfessionalManagementUseCaseInterface,
    private readonly _updateProfessionalManagementUseCase: UpdateProfessionalManagementUseCaseInterface,
    private readonly _getAllProfessionalsNotPaginatedUseCase: GetAllProfessionalsNotPaginatedUseCaseInterface,
    private readonly _getProfessionalOverviewUseCase: GetProfessionalOverviewUseCaseInterface,
  ) {}

  async getAllProfessionals(
    params: GetAllProfessionalsParams,
  ): Promise<GetAllProfessionalsUseCaseInterface.Result> {
    return await this._getAllProfessionalsUseCase.execute(params);
  }

  async getAllProfessionalsSelectOptions(
    params: GetAllProfessionalsSelectOptionsUseCaseInterface.Params,
  ): Promise<GetAllProfessionalsSelectOptionsUseCaseInterface.Result> {
    return await this._getAllProfessionalsSelectOptionsUseCase.execute(params);
  }

  async unlinkProfessional(
    params: UnlinkProfessionalUseCaseInterface.Params,
  ): Promise<UnlinkProfessionalUseCaseInterface.Result> {
    return await this._unlinkProfessionalUseCase.execute(params);
  }

  async getAllCheckProfessionalExists(
    params: GetAllCheckProfessionalExistsUseCaseInterface.Params,
  ): Promise<GetAllCheckProfessionalExistsUseCaseInterface.Result> {
    return await this._getAllCheckProfessionalExists.execute(params);
  }

  async createProfessionalManagement(
    params: CreateProfessionalManagementUseCaseInterface.Params,
  ): Promise<CreateProfessionalManagementUseCaseInterface.Result> {
    return await this._createProfessionalManagementUseCase.execute(params);
  }

  async getByIdProfessionalManagement(
    params: GetByIdProfessionalManagementUseCaseInterface.Params,
  ): Promise<GetByIdProfessionalManagementUseCaseInterface.Result> {
    return await this._getByIdProfessionalManagementUseCase.execute(params);
  }

  async updateProfessionalManagement(
    params: UpdateProfessionalManagementUseCaseInterface.Params,
  ): Promise<UpdateProfessionalManagementUseCaseInterface.Result> {
    return await this._updateProfessionalManagementUseCase.execute(params);
  }

  async getAllProfessionalsNotPaginated(
    params: GetAllProfessionalsNotPaginatedUseCaseInterface.Params,
  ): Promise<GetAllProfessionalsNotPaginatedUseCaseInterface.Result> {
    return await this._getAllProfessionalsNotPaginatedUseCase.execute(params);
  }

  async getProfessionalOverview(
    params: GetProfessionalOverviewUseCaseInterface.Params,
  ): Promise<GetProfessionalOverviewUseCaseInterface.Result> {
    return await this._getProfessionalOverviewUseCase.execute(params);
  }
}
